import { atom } from 'jotai';

export const activeProductAtom = atom<string | undefined>(undefined);
